import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Home from "./components/Home"; // Create a Home component
import PrivateRoute from "./components/PrivateRoute";
import Navbar from "./components/Navbar"; // Optional: A navigation bar

const App = (): React.JSX.Element => {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />
        {/* Add more protected routes as needed */}
      </Routes>
    </>
  );
};

export default App;
